import React from "react";

import { useGroupsSettings } from "./hooks/useGroupsSettings";

import GroupsHeader from "./components/GroupsHeader";
import GroupsKpiCards from "./components/GroupsKpiCards";
import GroupsFiltersCard from "./components/GroupsFiltersCard";
import GroupsTable from "./components/GroupsTable";
import GroupFormDrawer from "./components/GroupFormDrawer";

export default function SettingsGroups() {
  const dashboard = useGroupsSettings();

  return (
    <div className="space-y-5">
      <GroupsHeader onCreate={dashboard.openCreateDrawer} />

      <GroupsKpiCards
        stats={dashboard.stats}
        filteredStats={dashboard.filteredStats}
        loading={dashboard.loading}
      />

      <GroupsFiltersCard
        filters={dashboard.filters}
        setFilter={dashboard.setFilter}
        resetFilters={dashboard.resetFilters}
        dojos={dashboard.dojos}
        loading={dashboard.loading || dashboard.loadingMeta}
        filteredCount={dashboard.filteredGroups.length}
        totalCount={dashboard.groups.length}
        isQuotaActive={dashboard.isQuotaActive}
        quotaUpdating={dashboard.quotaUpdating}
        onToggleQuota={dashboard.handleToggleQuota}
        onRefresh={dashboard.refreshAll}
      />

      <GroupsTable
        groups={dashboard.filteredGroups}
        dojos={dashboard.dojos}
        loading={dashboard.loading}
        isQuotaActive={dashboard.isQuotaActive}
        deletingId={dashboard.deletingId}
        clearingId={dashboard.clearingId}
        activatingId={dashboard.activatingId}
        reordering={dashboard.reordering}
        onEdit={dashboard.openEditDrawer}
        onDuplicate={dashboard.openDuplicateDrawer}
        onDelete={dashboard.handleDeleteGroup}
        onClearMembers={dashboard.handleClearGroupMembers}
        onToggleActive={dashboard.handleToggleActive}
        onMoveUp={(group) => dashboard.moveGroup(group.id, "up")}
        onMoveDown={(group) => dashboard.moveGroup(group.id, "down")}
      />

      <GroupFormDrawer
        isOpen={dashboard.drawerOpen}
        mode={dashboard.drawerMode}
        group={dashboard.drawerGroup}
        defaultDojoId={dashboard.filters.dojoId}
        nextOrder={dashboard.nextOrder}
        dojos={dashboard.dojos}
        enseignants={dashboard.enseignants}
        disciplineSuggestions={dashboard.disciplineSuggestions}
        submitting={dashboard.submittingDrawer}
        onClose={dashboard.closeDrawer}
        onSubmit={dashboard.handleSubmitGroup}
      />
    </div>
  );
}